import { FormErrorMessage } from 'src/common/FormErrorMessage';

export function TripPayerInactiveWarning() {
  return (
    <FormErrorMessage>
      <h2 className="text-lg">Trip payer is inactive</h2>
      <p className="text-sm text-gray-500">
        This trip will not be visible on the dispatch calendar because its payer
        is inactive. In order to make it visible, please activate the payer or
        select an active payer.
      </p>
    </FormErrorMessage>
  );
}
